import React from 'react';
import { Handle, Position } from 'reactflow';

// One node on the canvas. Its content comes from the node catalog (name,
// category, parameter schema) plus the stored result of the last run.
export default function NodeCard({ data, selected }) {
  const meta = data.meta || {};
  const category = meta.category || 'transform';
  const result = data.result;
  const failed = result && result.status === 'failed';

  return (
    <div className={nodeClass(category, selected, failed, meta.terminal)}>
      {data.nodeType !== 'source' && <Handle type="target" position={Position.Left} />}
      <header className="flow-node-head">
        <span className="flow-node-icon material-symbols-rounded" aria-hidden="true">
          {iconFor(category)}
        </span>
        <span className="flow-node-title">{meta.name || data.nodeType}</span>
      </header>
      <ul className="flow-node-summary">
        {summaries(data).map((text, index) => (
          <li key={index}>{text}</li>
        ))}
      </ul>
      <footer className="flow-node-foot">
        {result ? (
          <span
            className={failed ? 'flow-node-error' : 'flow-node-count'}
            title={failed ? result.error : undefined}
          >
            {failed ? result.error : `${result.count} rows`}
          </span>
        ) : (
          <span className="flow-node-idle">not run</span>
        )}
      </footer>
      {!meta.terminal && <Handle type="source" position={Position.Right} />}
    </div>
  );
}

function nodeClass(category, selected, failed, terminal) {
  return [
    'flow-node',
    `flow-node-${category}`,
    terminal ? 'flow-node-terminal' : '',
    selected ? 'flow-node-selected' : '',
    failed ? 'flow-node-failed' : ''
  ]
    .filter(Boolean)
    .join(' ');
}

function iconFor(category) {
  if (category === 'input') return 'dataset';
  if (category === 'output') return 'bar_chart';
  return 'tune';
}

// Short human summary of the configured parameters, so the canvas stays
// readable without opening the inspector.
function summaries(data) {
  const params = data.params || {};
  return ((data.meta && data.meta.params) || [])
    .filter((param) => param.type !== 'chartConfig')
    .map((param) => {
      const value = params[param.key];
      const text = valueText(value);
      if (!text) return null;
      return (
        <span key={param.key}>
          <span className="flow-node-label">{param.label || param.key}:</span> {text}
        </span>
      );
    })
    .filter(Boolean)
    .slice(0, 3);
}

function valueText(value) {
  if (value == null || value === '') return '';
  if (Array.isArray(value)) {
    if (!value.length) return '';
    if (typeof value[0] === 'object') return `${value.length} entries`;
    return value.map(prettify).join(', ');
  }
  if (typeof value === 'object')
    return Object.keys(value).length ? `${Object.keys(value).length} options` : '';
  return prettify(value);
}

function prettify(value) {
  const text = String(value).replace(/__/g, ' · ').replace(/_/g, ' ');
  return text.charAt(0).toUpperCase() + text.slice(1);
}
